import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import * as FileSaver from 'file-saver';
import { Utils } from '../../../shared/utils';
import { ResumeComponent } from '../resume.component';
import { ResumeService } from '../resume.service';
import { BalanceModel } from './balance.model';
import { consts } from '../../../consts';


@Component({
    selector: 'convfact-balance-dialog',
    templateUrl: './balance-dialog.component.html',
    styleUrls: ['./balance.component.css'],
    standalone: false
})
export class BalanceDialogComponent implements OnInit {

  activityUid = this.data.activityUid;
  showGlobal = this.data.showGlobal;
  ready: boolean = false;
  fromDate: Date;
  toDate: Date;
  global: boolean;

  constructor(
    public dialogRef: MatDialogRef<ResumeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public resumeService: ResumeService,
    public snackBar: MatSnackBar,
  ) { }

  public closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.ready = true;
  }

  public convertDate(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return day + "-" + month + "-" + year;
  }

  public getBalance() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const balanceModel = new BalanceModel();

    balanceModel.from = Utils.DateFormatString(this.fromDate);
    balanceModel.to = Utils.DateFormatString(this.toDate);

    balanceModel.global = this.global;
    this.ready = false;
    this.resumeService.getBalance(balanceModel).then(response => {
      FileSaver.saveAs(response, "balance.xlsx");
      this.ready = true;
    }).catch(err => {
      this.ready = true;
      this.displayInfo("Ha ocurrido un error al generar el documento excel de balance de sumas y saldos");
    });
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
